module.exports = __webpack_public_path__ + "img/one_col.73e4a835.svg";